import { h, Component } from 'preact'
import linkState from 'linkstate'

import { connect } from 'app/store'
import Input from 'app/components/Input'
import Form from 'app/components/Form'
import { api } from 'app/util/api'
import cxs from 'cxs'

const inputClass = cxs({
  padding: '0.5rem',
  fontSize: '1rem',
  border: '2px solid #f6f6f6',
  borderRadius: 0,
  backgroundColor: '#f6f6f6',
  color: '#343334',
  '-webkit-appearance': 'none',
  '-moz-appearance': 'none',
  appearance: 'none',
  height: '51px',
  width: '100%',
})

const initialState = {
  loading: false,
  url: '',
}

class NewBookmark extends Component {
  state = {
    ...initialState,
  }

  /**
   * Misc/helpers
   */

  /**
   * Form
   */
  submitUrl = async () => {
    const { url } = this.state

    this.setState({ loading: true })

    try {
      await api.post('/bookmark', { url })
      this.setState({ ...initialState })
    } catch (error) {
      this.setState({ ...initialState, url })
    }

    if (this.props.onCreate) {
      await this.props.onCreate()
    }
  }

  render() {
    return (
      <Form
        autocomplete="off"
        class="mb-0 mb-sm-1 mb-md-4 mb-lg-4 mb-xl-4"
        onSubmit={() => this.submitUrl()}
        >
        <Input
          type="text"
          placeholder={`Enter url...`}
          value={this.state.url}
          onInput={linkState(this, 'url')}
          class={inputClass}
          required
          disabled={this.state.loading}
          autocomplete="off"
        />
      </Form>
    )
  }
}

export default connect(
  null,
  NewBookmark,
)



// WEBPACK FOOTER //
// ./components/NewBookmark.js